import Dispatcher from '../dispatcher';

export default {

  setInfo(info) {
    Dispatcher.emit(Dispatcher.USER_SET_INFO, info);
  },

  changePassword(info){
    Dispatcher.emit(Dispatcher.USER_CHANGE_PASSWORD, info);
  },

  updateSecurityQuestion(info){
    Dispatcher.emit(Dispatcher.USER_UPDATE_SECURITY_QUESTION, info);
  },

  updateNotificationSetting(info){
    Dispatcher.emit(Dispatcher.USER_UPDATE_NOTIFICATION, info);
  },

  signOut() {
    Jigsaw.User.signOut(()=>{
      Dispatcher.emit(Dispatcher.USER_SIGN_OUT);
      Routes.setRoute("logout");
    });
  }

}



/** WEBPACK FOOTER **
 ** ./src/js/actions/user-action.js
 **/